import korea from "vee-validate/dist/locale/ko.json";

class Constant {
  validate = {
    language: {
      korea: korea,
    },
  };
  map = {
    kakaoRestApiKey: "4d2469516db02caafb9655b3dd1f6e88",
  };

  sensor = {
    inEnvList: [
      {
        label: "온도",
        fieldName: "temp",
        unit: "℃",
        range: { min: -50, max: 50 },
        colorHex: "#ff6600",
      },
      {
        label: "습도",
        fieldName: "humidity",
        unit: "%",
        range: { min: 0, max: 100 },
        colorHex: "#1495ff",
      },
      {
        label: "co2",
        fieldName: "co2",
        unit: "ppm",
        range: { min: 0, max: 5000 },
        colorHex: "#56a70f",
      },
      {
        label: "일사량",
        fieldName: "solarRadiation",
        unit: "",
        range: { min: 0, max: 1000 },
        colorHex: "#790cb1",
      },
    ],

    rootEnvList: [
      {
        label: "온도",
        fieldName: "temp",
        unit: "℃",
        range: { min: -50, max: 50 },
        colorHex: "#ff6600",
      },
      {
        label: "습도",
        fieldName: "humidity",
        unit: "%",
        range: { min: 0, max: 100 },
        colorHex: "#1495ff",
      },
      {
        label: "배액EC",
        fieldName: "drainageEc",
        unit: "",
        range: { min: 0, max: 100 },
        colorHex: "#56a70f",
      },
      {
        label: "배액PH",
        fieldName: "drainagePh",
        unit: "",
        range: { min: 0, max: 100 },
        colorHex: "#790cb1",
      },
    ],
    nutrientSolutionList: [
      {
        label: "EC",
        fieldName: "ec",
        unit: "",
        range: { min: 0, max: 100 },
        colorHex: "#56a70f",
      },
      {
        label: "PH",
        fieldName: "ph",
        unit: "",
        range: { min: 0, max: 100 },
        colorHex: "#790cb1",
      },
      {
        label: "공급유량",
        fieldName: "flowRate",
        unit: "",
        range: { min: 0, max: 100 },
        colorHex: "#ff6600",
      },
      {
        label: "공급성분농도",
        fieldName: "constConcen",
        unit: "",
        range: { min: 0, max: 100 },
        colorHex: "#1495ff",
      },
    ],
  };
}

export default new Constant();
